import React, { useEffect } from "react";
import { Circle, OptionsWrapper, RadiusButton, EvolutiveChartContainer, Text, Title, Square } from "./style";
import { BARRAS_AGRUPADAS, LINE } from "src/components/Charts/types";

export const ReportEvolutiveChart = ({
  onChartEdit,
  chartData
}) => {

  const handleCircleCheck = (type) => {
    const newChartData = {...chartData, render: type};
    onChartEdit(newChartData);
  }

  const handleSquareCheck = (configId) => {
    const newChartData = {
      ...chartData,
      configuracoes: chartData.configuracoes.map((c) =>
        c.id_configuracao === configId
          ? { ...c, checked: !c.checked }
          : c
      ),
    };
    onChartEdit(newChartData);
  };

  return (
    <EvolutiveChartContainer>
      <Title>Selecione o modelo de gráfico a ser exibido</Title>
      <OptionsWrapper onClick={() => handleCircleCheck(LINE)}>
          <RadiusButton>
            <Circle isChecked={chartData.render === LINE}/>
          </RadiusButton>
        <Text>Modelo de gráfico de linhas</Text>
      </OptionsWrapper>

      <OptionsWrapper onClick={() => handleCircleCheck(BARRAS_AGRUPADAS)}>
          <RadiusButton>
            <Circle isChecked={chartData.render === BARRAS_AGRUPADAS} />
          </RadiusButton>
        <Text>Modelo de gráfico de barras</Text>
      </OptionsWrapper>
      <Title>Selecione quais evolutivos você deseja exibir no relatório</Title>
      {
        chartData?.configuracoes?.map((config, index) => 
          <OptionsWrapper 
            onClick={() => handleSquareCheck(config.id_configuracao)}
            key={index}
          >
            <RadiusButton>
              <Square isChecked={config.checked}/>
            </RadiusButton>
            <Text>{config.titulo_configuracao}</Text>
          </OptionsWrapper>
        )
      }
    </EvolutiveChartContainer>
  );
}